var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconLinklist(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25200_5986)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_25200_5986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.842 21.653L13.8109 18.6783C14.6014 17.9116 15.5536 17.0074 15.9498 15.9755C17.2637 13.2651 16.0597 9.69137 13.3982 8.28564H13.3865C13.0482 8.66193 12.0234 9.49628 11.9451 10.0061C12.8554 10.3391 13.6461 11.1547 14.0085 12.0579C14.5915 13.4561 14.2506 15.1469 13.1831 16.2196H13.1715L9.29005 20.1127C7.86993 21.5942 5.32114 21.6006 3.8961 20.1126C2.4488 18.6712 2.4488 16.166 3.8961 14.7187L5.66762 12.9472C5.41197 12.0476 5.27525 11.1678 5.31888 10.2096L2.34418 13.1785C0.018574 15.412 0.0186331 19.4227 2.34425 21.653C4.57816 23.9847 8.61794 23.9725 10.842 21.653Z",
    fill: "CurrentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.53341 11.087C7.67809 13.0146 8.88951 14.8324 10.5791 15.7544C10.9265 15.3576 11.9154 14.5728 12.0381 14.0398C10.3761 13.4059 9.43059 11.5008 9.77706 9.77341C9.89763 8.27572 11.9609 6.74093 12.8925 5.71629C13.9835 4.5939 15.6557 2.72326 17.3785 2.81148C20.7255 2.74406 22.472 6.98662 20.0811 9.31555C20.0812 9.31551 18.2981 11.0987 18.2981 11.0987C18.5537 11.9692 18.7173 12.9205 18.6352 13.8421L21.6157 10.8616C27.0133 5.00444 18.9895 -3.00781 13.1411 2.3871C13.1411 2.38708 10.1723 5.35596 10.1723 5.35596C8.50182 6.80978 7.23808 8.79266 7.53341 11.087Z",
    fill: "CurrentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25200_5986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "CurrentColor"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_25200_5986"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "CurrentColor"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLinklist);
export default __webpack_public_path__ + "static/media/icon-linklist.f1f3cc591aed5097518a9a2b018c4e1d.svg";
export { ForwardRef as ReactComponent };